'use client';

import { useEffect, useState } from 'react';

interface PageAtmosphereProps {
  gradient: [string, string];
  mood: string;
  timeOfDay?: string;
  brightness: 'light' | 'medium' | 'dark';
}

export default function PageAtmosphere({
  gradient,
  mood,
  timeOfDay,
  brightness
}: PageAtmosphereProps) {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    // Fade in atmosphere
    const timer = setTimeout(() => setOpacity(1), 100);
    return () => clearTimeout(timer);
  }, [gradient]);

  // Brightness opacity mapping - INCREASED for better visibility
  const brightnessMap = {
    light: 0.25,
    medium: 0.35,
    dark: 0.5
  };

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: `linear-gradient(135deg, ${gradient[0]} 0%, ${gradient[1]} 100%)`,
        opacity: opacity * brightnessMap[brightness],
        transition: 'opacity 0.8s ease-in-out',
        pointerEvents: 'none',
        zIndex: 20,
        borderRadius: 'inherit',
      }}
    />
  );
}

